import { useMemo, useState } from "react"
import { DiscoverResultsRow } from "./discover_results_row"
import { TooltipProvider } from "~/react/ui/tooltip"
import type { DiscoverDomain } from "~/react/types/discover"
import { Sheet, SheetContent } from "@/react/ui/sheet"
import { CompanyDetails } from "@/react/components/company/details"

interface DiscoverResultsTableProps {
  domains: DiscoverDomain[]
  domainsWithRecentFundings: number[]
  domainsCurrentlyHiring: number[]
  numberOfCreditsLeft: number
  singleCreditsBucket: boolean
}

export function DiscoverResultsTable({
  domains,
  domainsWithRecentFundings,
  domainsCurrentlyHiring,
  numberOfCreditsLeft,
  singleCreditsBucket,
}: DiscoverResultsTableProps) {
  // Convert arrays to Sets for O(1) lookup performance
  const fundingsSet = useMemo(
    () => new Set(domainsWithRecentFundings),
    [domainsWithRecentFundings],
  )
  const hiringSet = useMemo(
    () => new Set(domainsCurrentlyHiring),
    [domainsCurrentlyHiring],
  )
  const [selectedDomain, setSelectedDomain] = useState<DiscoverDomain | null>(
    null,
  )

  return (
    <TooltipProvider>
      <Sheet
        open={selectedDomain !== null}
        onOpenChange={(open) => setSelectedDomain(open ? selectedDomain : null)}
      >
        <SheetContent overlay={false} className="p-0">
          {selectedDomain && (
            <CompanyDetails
              domain={selectedDomain}
              numberOfCreditsLeft={numberOfCreditsLeft}
              singleCreditsBucket={singleCreditsBucket}
            />
          )}
        </SheetContent>
      </Sheet>
      <div
        className="h-table__scrollable"
        data-horizontal-scroll-position="start"
      >
        <table>
          <tbody>
            {domains.map((domain) => (
              <DiscoverResultsRow
                key={domain.id}
                domain={domain}
                hasRecentFunding={fundingsSet.has(domain.id)}
                isHiring={hiringSet.has(domain.id)}
                onClick={() => setSelectedDomain(domain)}
              />
            ))}
          </tbody>
        </table>
      </div>
    </TooltipProvider>
  )
}
